import React, { Component } from 'react'
import intl from 'react-intl-universal'
import ReactDOM from 'react-dom'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import PropTypes from 'prop-types'
import AuthorisationHandler from '../components/AuthorisationHandler'
import paypal from 'paypal-checkout'
import shortid from 'shortid'
import moment from 'moment'
import 'moment-timezone'
import Page from './Page'
import Loading from '../components/Loading'
// import Input from '../components/Input'
import Select from 'react-select'
import object_value from '../api/object_value'
import return_html from '../api/return_html'

@inject('user', 'experiences', 'book_experience_store', 'my_bookings')
@observer
class BookExperiencePage extends Component {
  constructor (props, context) {
    super(props, context)
    this.state = {status: null}

    const {
      user,
      experiences,
      book_experience_store,
      my_bookings
    } = props

    experiences.clean()
    book_experience_store.clean()

    const experience_id = object_value(this, 'props.match.params.experience_id')
    experiences.get(experience_id)
    book_experience_store.set('experience_id', parseInt(experience_id))

    const event_id = object_value(this, 'props.match.params.event_id')
    book_experience_store.set('event_id', parseInt(event_id))

    const {token} = user
    my_bookings.get(token)
  }

  is_booked_by_user = () => {
    const {
      book_experience_store,
      my_bookings
    } = this.props

    return my_bookings.is_booked(book_experience_store.experience_id, book_experience_store.event_id)
  }

  stepIsDisabled = (step) => {
    // const {state} = this
    const {book_experience_store} = this.props

    step = parseInt(step)
    let step_2 = !book_experience_store.number_guests

    if (step === 1) {
      return false
    }

    if (step === 2) {
      return step_2
    }

    return true
  }

  handleStepChange = (step) => {
    const {book_experience_store} = this.props
    book_experience_store.set('current_step', parseInt(step))
  }

  handleSubmit = async (event) => {
    event.preventDefault()
    console.log('BookExperiencePage.js - handleSubmit()', event)
    const {user, book_experience_store} = this.props
    const {current_step, steps} = book_experience_store

    // Next step
    console.log('BookExperiencePage.js - handleSubmit() - step', current_step, steps.length)
    if (current_step < steps.length) {
      book_experience_store.set('current_step', current_step + 1)
      return
    }

    // Moved to Paypal onAuthorize
    // const {token} = user
    // book_experience_store.request(token)
  }

  handleInputChange = async (event) => {
    console.log('BookExperiencePage.js - handleInputChange() - event.target', event.target)
    console.log('BookExperiencePage.js - handleInputChange() - event.value', event.value)
    const target = event.target

    let value = event.value
    if (target) {
      if (target.type === 'checkbox') {
        value = target.checkbox
      } else if (target.type === 'number' || target.type === 'radio') {
        value = parseInt(target.value)
      } else {
        value = target.value
      }
    }

    const name = target
      ? target.name
      : event.name

    console.log('handleInputChange()', name, value)

    const {book_experience_store} = this.props
    book_experience_store.set(name, value)
  }

  handleNumberGuestsChange = ({label, value}) => {
    console.log('number_guests', value, label)

    const {book_experience_store} = this.props
    book_experience_store.set('number_guests', parseInt(value))
  }

  handleRestart = () => {
    const {book_experience_store} = this.props
    book_experience_store.restart_form()
  }

  render () {
    const {
      user,
      experiences,
      book_experience_store,
      my_bookings
    } = this.props

    if (!my_bookings.loaded) {
      return (
        <Page title='Book event - Loading...'>
          <div><Loading /></div>
        </Page>
      )
    }

    if (this.is_booked_by_user() === true) {
      return (
        <Page title='Book event - Already booked'>
          <article className='b-info'>
            <h2 className='b-info-title'>{intl.get('booking.is_already_booked')}</h2>
          </article>
        </Page>
      )
    }

    const {token} = user
    const experience_loaded = experiences.loaded
    const experience = experiences.data
    const {
      event_id,
      status,
      status_message,
      steps,
      current_step,
      number_guests
    } = book_experience_store
    console.log('BookExperiencePage.js - render() - book_experience_store', book_experience_store)

    const event = experiences.computed__event({event_id})
    console.log('BookExperiencePage.js - render() - event', event)

    let event_date = object_value(event, 'date')
    if (event_date) {
      event_date = moment(event_date).utc()/*.tz('Europe/Berlin')*/.format('DD.MM.YYYY — HH:mm')
    }

    let event_free_places = object_value(event, 'free_places', 0)
    let number_guests_options = Array.from(new Array( parseInt(event_free_places) ), (val, index) => ({value: index + 1, label: index + 1}))

    let total_price = () => number_guests * experience.price

    function stepClass (step, baseStyle = '') {
      let isCurrent = current_step === step
      return isCurrent ? baseStyle + ' current' : baseStyle
    }

    if (status === 'error') {
      return (
        <Page title='Information'>
          <article className='b-info'>
            <h2 className='b-info-title'>Something went wrong :(</h2>
            <p><button className='b-button'
                       onClick={this.handleRestart}>Retry</button></p>
            <h3 className='b-info-subtitle'>Error</h3>
            <code dangerouslySetInnerHTML={return_html(status_message.toString())} />
          </article>
        </Page>
      )
    }

    if (status === 'success') {
      return (
        <Page title='Information'>
          <article className='b-info'>
            <h2 className='b-info-title'>{intl.get('booking.is_booked_and_paid')}</h2>
            <p>{intl.get('booking.is_booked_and_paid_message')}</p>
          </article>
        </Page>
      )
    }

    // Paypal

    console.log('experience:', experience)

    const paypal_env = 'sandbox'

    const paypal_client = {
      sandbox:    'AS9zAWpQg3IgOuKvukqE1-jKU2UR2AA5QInpCI-jv6qzs-UEGYamlv8bBKvoIJPe-clcGINI6nrNyglG',
      production: 'YOUR-PRODUCTION-APP-ID'
    }

    const paypal_funding = {
      allowed: [ paypal.FUNDING.CARD ],
      // disallowed: [ paypal.FUNDING.ELV, paypal.FUNDING.CREDIT ]
    }

    const paypal_style = {
      // layout: 'vertical', // horizontal | vertical
      size: 'large',      // medium | large | responsive
      shape: 'rect',      // pill | rect
      color: 'gold'       // gold | blue | silver | black
    }

    // In order to get production's app-ID, you will have to send your app to Paypal for approval first
    // For sandbox app-ID (after logging into your developer account, please locate the "REST API apps" section, click "Create App"):
    //   => https://developer.paypal.com/docs/classic/lifecycle/sb_credentials/
    // For production app-ID:
    //   => https://developer.paypal.com/docs/classic/lifecycle/goingLive/

    const paypal_payment = (data, actions) => {
      console.log('BookExperiencePage - paypal - payment - data', data)
      console.log('BookExperiencePage - paypal - payment - actions', actions)

      return actions.payment.create({
        payment: {
          transactions: [
            {
              amount: {
                total:    total_price(),
                currency: 'EUR'
              }
            }
          ]
        },
        experience: {
          input_fields: {
            no_shipping: 1 // disable collection of shipping addresses
          }
        }
      })
    }

    const paypal_onError = (error) => {
      // The main Paypal's script cannot be loaded or somethings block the loading of that script!
      console.log('BookExperiencePage - paypal - onError - error:', error)
      // Because the Paypal's main script is loaded asynchronously from "https://www.paypalobjects.com/api/checkout.js"
      // => sometimes it may take about 0.5 second for everything to get set, or for the button to appear
      book_experience_store.set('status_message', 'Paypal checkout loading error:\n' + error)
      book_experience_store.set('status', 'error')
    }

    const paypal_onAuthorize = (data, actions) => {
      console.log('BookExperiencePage - paypal - onAuthorize - data', data)
      console.log('BookExperiencePage - paypal - onAuthorize - actions', actions)

      return actions.payment.execute()
        .then(response => {
          console.log('BookExperiencePage - paypal - onAuthorize - response:', response)

          const payment_obj = {
            payment_id: object_value(response, 'transactions[0].related_resources[0].sale.id', 'no_id'),
            payment_email: object_value(response, 'payer.payer_info.email', 'no_email'),
            payment_amount: object_value(response, 'transactions[0].related_resources[0].sale.amount.total', 'no_amount') + ' ' +
                            object_value(response, 'transactions[0].related_resources[0].sale.amount.currency', 'no_currency'),
            payer_id: object_value(response, 'payer.payer_info.payer_id', 'no_payer_id'),
            payment_phone: object_value(response, 'payer.payer_info.phone', 'no_phone'),
            payment_first_name: object_value(response, 'payer.payer_info.first_name', 'no_first_name'),
            payment_middle_name: object_value(response, 'payer.payer_info.middle_name', 'no_middle_name'),
            payment_last_name: object_value(response, 'payer.payer_info.last_name', 'no_last_name')
          }

          book_experience_store.request(token, payment_obj)
        })
        .catch(error => {
          console.log('BookExperiencePage - paypal - onAuthorize - error:', error)
          book_experience_store.set('status_message', 'Paypal checkout error:\n' + error)
          book_experience_store.set('status', 'error')
        })
    }

    const paypal_onCancel = (data) => {
      console.log('BookExperiencePage - paypal - onCancel - data', data)
      console.log('The payment was cancelled!')
    }

    const PayPalButton = paypal.Button.driver('react', { React, ReactDOM })

    return (
      <AuthorisationHandler check_if_confirmed={true}>
        <Page title='Book event'>
          {status === 'loading' || !experience_loaded || this.is_booked_by_user() === 'loading' ? <div><Loading /></div> :
          <section className='b-create-event'>
            <div className='b-create-event-indicator'>
              {steps.map((name, index) =>
                <div className={stepClass(index + 1, 'b-create-event-indicator-step')}
                     key={shortid.generate()}>
                  <button className={stepClass(index + 1, 'b-create-event-indicator-step-button')}
                          disabled={index > 0 && this.stepIsDisabled(index)}
                          type='button'
                          onClick={() => this.handleStepChange(index + 1)}>
                    <span
                      className='b-create-event-indicator-step-button-label'>{name}</span>
                    <span
                      className='b-create-event-indicator-step-button-index'>{index + 1}</span>
                  </button>
                </div>
              )}
            </div>

            {/* step 1 */}
            <div className={stepClass(1, 'b-create-event-form-step')}>
              <h2 className='b-create-event-title'>{intl.get('booking.check_conditions')}</h2>

              <div className='b-form-row'>
                <div className='b-event-details'>
                  <div className='b-event-details-blocks'>
                    <div className='b-event-details-block'>
                      <div className='b-event-details-block-label'>
                        <div className='b-event-details-block-image'
                             style={experience.image_url
                               ? { backgroundImage: 'url(' + experience.image_url + ')' }
                               : {}} />
                      </div>
                      <div className='b-event-details-block-value'>
                        {event_date}
                      </div>
                    </div>
                  </div>
                  <div className='b-event-details-blocks'>
                    <div className='b-event-details-block'>
                      <div className='b-event-details-block-label'>{intl.get('experiences.comment_label')}</div>
                      <div className='b-event-details-block-value'>
                        {experience.description}
                      </div>
                    </div>
                  </div>
                  <div className='b-event-details-blocks'>
                    <div className='b-event-details-block'>
                      <div className='b-event-details-block-label'>{intl.get('experiences.comment_label')}</div>
                      <div className='b-event-details-block-value'>
                        {experience.comment}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='b-form-row'>
                <div className='b-form-item'>
                  <button className='b-button b-button_primary b-button_x'
                          onClick={() => this.handleStepChange(2)}
                          disabled={this.stepIsDisabled(1)}>
                    {intl.get('Next')}
                  </button>
                </div>
              </div>
            </div>

            {/* step 2 */}
            <form className={stepClass(2, 'b-create-event-form-step')}
                  onSubmit={this.handleSubmit}>
              <h2 className='b-create-event-subtitle'>{intl.get('booking.confirmation_and_payment')}</h2>

              {event_free_places > 0
                ? <div>
                    <div className='b-form-row'>
                      <div className='b-form-item b-form-item_x'>
                        <div className='b-form-item-wrapSelect'>
                          <Select id='number_guests'
                                  name='number_guests'
                                  value={number_guests}
                                  options={number_guests_options}
                                  onChange={this.handleNumberGuestsChange}
                                  searchable={false}
                                  required />
                        </div>
                        <label className='b-form-item-label'
                               htmlFor='city_id'>
                          {intl.get('Guests')}
                        </label>
                      </div>
                    </div>

                    <hr />

                    <div className='b-create-event-text'>
                      {intl.get('Price')}: {total_price()} €
                    </div>

                    <div className='b-create-event-text'>
                      {intl.get('booking.continue_with_paypal')}:
                    </div>

                    <PayPalButton
                      env={paypal_env}
                      // funding={paypal_funding}
                      client={paypal_client}
                      style={paypal_style}
                      payment={paypal_payment}
                      commit={true}
                      onAuthorize={paypal_onAuthorize}
                      onCancel={paypal_onCancel}
                      onError={paypal_onError}
                    />
                  </div>
                : <div className='b-create-event-text'>
                  {intl.get('booking.no_free_places')}
                  </div>
              }
            </form>

          </section>}
        </Page>
      </AuthorisationHandler>
    )
  }
}

BookExperiencePage.propTypes = {
  user: MobxPropTypes.observableObject,
  experiences: MobxPropTypes.observableObject,
  book_experience_store: MobxPropTypes.observableObject,
  my_bookings: MobxPropTypes.observableObject,
  history: PropTypes.any,
  location: MobxPropTypes.objectOrObservableObject
}

export default BookExperiencePage



// WEBPACK FOOTER //
// ./src/containers/BookExperiencePage.js